export default __webpack_public_path__ + "static/banner_1-7a51b195410ee1d71ca306eacffac4f5.webp";